import { UserResource } from 'src/app/user/resource/user.resource';

export class SubmitterResource extends UserResource  {
    id: number;

}


